export default "__VITE_ASSET__CbQePGCV__"